/* eslint-disable react/prop-types */
/* eslint-disable react/jsx-props-no-spreading */
import React from 'react';
import PropTypes from 'prop-types';
import { useTranslation } from 'react-i18next';
import { Icon, Menu } from 'semantic-ui-react';
import { Link } from 'react-router-dom';
import * as Icons from '../../assets/icons';
import Paths from '../../constants/Paths';

import NotificationsPopup from './NotificationsPopup';
import UserPopup from '../UserPopup';

import styles from './Header.module.scss';

const Icon2 = ({ icon, ...props }) => {
  const IconItem = Icons[icon];
  return <IconItem {...props} />;
};

const Header = React.memo(
  ({
    themeMode,
    alerts,
    notifications,
    isAdmin,
    isManager,
    onUsers,
    onNotificationDelete,
    onUserSettings,
    onLogout,
    toggleMode,
    toggleMenu,
  }) => {
    const [t] = useTranslation();
    const toggleTheme = () => {
      toggleMode();
      if (themeMode === 'light') {
        localStorage.setItem('theme', 'dark');
      } else {
        localStorage.setItem('theme', 'light');
      }
    };

    return (
      <div className={styles.wrapper}>
        <button
          type="button"
          className={styles.button_toggle_menu}
          aria-label="Menu"
          onClick={toggleMenu}
        >
          <Icon2 icon="MenuIcon" aria-hidden="true" />
        </button>
        {/* <Search input={{ icon: 'search', iconPosition: 'left', className: 'search-input' }} /> */}
        <Menu size="large" className={styles.menu}>
          <Menu.Menu position="right">
            <Menu.Item className={styles.item}>
              <Link to={Paths.LIST_ALERTS} className={styles.alerts}>
                <span className={styles.numberAlerts}>{alerts[0] ? alerts[0].alertCount : 0}</span>
                {t('common.alert')}
              </Link>
            </Menu.Item>
            <Menu.Item className={styles.item}>
              <button
                onClick={toggleTheme}
                type="button"
                className={styles.button_color_mode}
                aria-label="Toggle color mode"
              >
                {themeMode === 'dark' ? <Icon fitted name="sun" /> : <Icon fitted name="moon" />}
              </button>
            </Menu.Item>
            {(isAdmin || isManager) && (
              <Menu.Item className={styles.item} onClick={onUsers}>
                <Icon fitted name="users" />
              </Menu.Item>
            )}
            <NotificationsPopup items={notifications} onDelete={onNotificationDelete}>
              <Menu.Item className={styles.item}>
                <Icon fitted name="bell" />
                {notifications.length > 0 && (
                  <span className={styles.notification}>{notifications.length}</span>
                )}
              </Menu.Item>
            </NotificationsPopup>
            <UserPopup onSettings={onUserSettings} onLogout={onLogout}>
              <Menu.Item className={styles.item}>
                <Icon fitted name="github" />
              </Menu.Item>
            </UserPopup>
          </Menu.Menu>
        </Menu>
      </div>
    );
  },
);

Header.propTypes = {
  alerts: PropTypes.arrayOf(PropTypes.any),
  notifications: PropTypes.arrayOf(PropTypes.string),
  isAdmin: PropTypes.bool.isRequired,
  isManager: PropTypes.bool.isRequired,
  onUsers: PropTypes.func.isRequired,
  onNotificationDelete: PropTypes.func.isRequired,
  onUserSettings: PropTypes.func.isRequired,
  onLogout: PropTypes.func.isRequired,
  toggleMenu: PropTypes.func.isRequired,
  toggleMode: PropTypes.func.isRequired,
};

Header.defaultProps = {
  notifications: undefined,
  alerts: undefined,
};

export default Header;
